import { render, staticRenderFns } from "./NotificationTemplateList.vue?vue&type=template&id=41d44eb3&"
import script from "./NotificationTemplateList.vue?vue&type=script&lang=ts&"
export * from "./NotificationTemplateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports